import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  dialogActions: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
  },
}));

AssignHostDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  isHost: PropTypes.bool,
};

export default function AssignHostDialog({ open, setOpen }) {
  const classes = useStyles();
  const [showUsers, setShowUsers] = useState(false);
  const [newHost, setNewHost] = useState('');
  const { isHost, attendeeId, roster } = useSelector(({ chime }) => ({
    isHost: chime.isHost,
    attendeeId: chime.attendeeId,
    roster: chime.roster,
  }));

  const handleClose = () => setOpen(false);

  const exitAsignNewHost = async () => {
    //@TODO: Fix this
    // await chime.assignNewHost(roster[newHost].externalUserId)
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{'Assign A New Host'}</DialogTitle>
        <DialogContent>
          {isHost && showUsers && (
            <Grid container>
              <Grid item xs={12}>
                <InputLabel htmlFor="filled-age-native-simple">New Host Name</InputLabel>
                <Select
                  native
                  fullWidth
                  value={newHost}
                  onChange={(e) => {
                    setNewHost(e.target.value);
                  }}
                >
                  <option value={''} />
                  {Object.keys(roster).map((thisAttendeeId) => {
                    if (attendeeId !== thisAttendeeId) {
                      return (
                        <option key={thisAttendeeId} value={thisAttendeeId}>
                          {roster[thisAttendeeId].name}
                        </option>
                      );
                    }
                    return null;
                  })}
                </Select>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={() => setOpen(false)} color="primary">
            Cancel
          </Button>
          {isHost && !!newHost && (
            <Button
              variant="contained"
              style={{ backgroundColor: 'orange' }}
              onClick={() => {
                exitAsignNewHost();
                setOpen(false);
              }}
            >{`Assign ${roster[newHost]?.name} As Host`}</Button>
          )}
          {isHost && !newHost && (
            <Button
              onClick={() => setShowUsers(true)}
              variant="contained"
              color="secondary"
              autoFocus
            >
              Assign A New Host
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
